
export default (store) => ({
  path: 'intro',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Intro = require('./containers/IntroContainer').default

      /*  Return getComponent   */
      cb(null, Intro)

    /* Webpack named bundle   */
    }, 'Intro')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/DecisionTool/routes/Intro/index.js
 **/